export type AnimationDelay = keyof typeof ANIMATION_DELAY;
export const ANIMATION_DELAY = {
    default: 0,
} as const;

export type AnimationDuration = keyof typeof ANIMATION_DURATION;
export const ANIMATION_DURATION = {
    default: 350,
    fast: 200,
} as const;

export type AnimationCurve = keyof typeof ANIMATION_CURVE;
export const ANIMATION_CURVE = {
    fastOutLinearIn: 'cubic-bezier(.4, 0, 1, 1)',
    fastOutSlowIn: 'cubic-bezier(.4, 0, .2, 1)',
    linearOutSlowIn: 'cubic-bezier(0, 0, .2, 1)',

    // same as fastOutSlowIn as a fallback
    default: 'cubic-bezier(.4, 0, .2, 1)',
} as const;
